/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConvertVersionRequestBody
 */
export interface ConvertVersionRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ConvertVersionRequestBody
     */
    versionName: string;
}

/**
 * Check if a given object implements the ConvertVersionRequestBody interface.
 */
export function instanceOfConvertVersionRequestBody(value: object): value is ConvertVersionRequestBody {
    if (!('versionName' in value) || value['versionName'] === undefined) return false;
    return true;
}

export function ConvertVersionRequestBodyFromJSON(json: any): ConvertVersionRequestBody {
    return ConvertVersionRequestBodyFromJSONTyped(json, false);
}

export function ConvertVersionRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConvertVersionRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'versionName': json['versionName'],
    };
}

export function ConvertVersionRequestBodyToJSON(json: any): ConvertVersionRequestBody {
    return ConvertVersionRequestBodyToJSONTyped(json, false);
}

export function ConvertVersionRequestBodyToJSONTyped(value?: ConvertVersionRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'versionName': value['versionName'],
    };
}

